import React, { useState } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";

import * as Const from "./_Const";

import Keyboard from "./components/Keyboard";
import Input from "./components/Input";

function PagePersonalLastName({ onNext, onPrev }) {
  const { getPageData, handleInputWithKeyboard, state, setCurrentStepIndex, isEmptyState, isInErrorState } = useFormCtx();
  const index = Const.REG_RPI_LAST_NAME_INDEX;
  const page = getPageData(index);

  const showTitle = !Const.isTerminal();

  function canShowNext() {
    return state.lastName && !isInErrorState ? true : false;
  }

  return (
    <>
      <PageWrapper title={page.title} index={index} showTitle={showTitle} showNext={canShowNext()}>
        <div className="mt-4 flex flex-col space-y-4 mx-6">
          <Input
            label="Příjmení"
            name="lastName"
            value={state.lastName}
            errorMessage={state.errors.lastName}
            autoComplete="off"
            readOnly={true}
            showClearIcon={true}
            onClear={(e) => handleInputWithKeyboard("lastName", "")}
          />

          <Keyboard type={"text"} onChange={(e) => handleInputWithKeyboard("lastName", e)} value={state.lastName} />
        </div>
      </PageWrapper>
    </>
  );
}

export default PagePersonalLastName;
